import './customizations/theme.less';

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['fr'];
  config.settings.defaultLanguage = 'fr';

  return config;
};

export default applyConfig;
